import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import InViewPort from "../utilities/in-viewport";


export const SecService = ({
    icon,
    topic,
    textDesc
}) => {
    return (
        <InViewPort>
            <div className="service glassy-effect">
                <div className="ico or-bg">
                    <FontAwesomeIcon icon={icon} color="#fff" />
                </div>
                <div className="service-cap">{topic}</div>
                <div className="service-text">{textDesc}</div>
            </div>
        </InViewPort>
    );
}